export default __webpack_public_path__ + "static/media/vision-section-04.55feb547.png";